import { z } from 'zod';

export const idSchema = z.string().uuid();
export type Id = z.infer<typeof idSchema>;

export const paginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(50),
});
export type Pagination = z.infer<typeof paginationSchema>;

export const errorResponseSchema = z.object({
  error: z.string(),
  message: z.string().optional(),
  issues: z.unknown().optional(),
});
export type ErrorResponse = z.infer<typeof errorResponseSchema>;
